module.exports = __webpack_public_path__ + "static/img/ElegantIcons.907b74d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/elegant_font/fonts/ElegantIcons.svg
// module id = 5pIz
// module chunks = 20